import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=1854d5ac"
import script from "./IconCheck.vue?vue&type=script&lang=ts"
export * from "./IconCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports